import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Importa estos hooks
import './galeryfirst.css';
import FiestaSpinner from '../../../shared/FiestaSpinner';

export const GaleryFirst = ({ imagePrincipal, otherImages }) => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate(); // Para cambiar de ruta
  const location = useLocation(); // Para obtener la ruta actual
  
  // Extraer solo las URLs de las imágenes en 'others'
  const otherImageUrls = otherImages.map(image => image.url);
  const imageFirstUrls = imagePrincipal.map(image => image.url);

  // Combina la imagen principal con las imágenes adicionales en un solo arreglo
  const images = [imageFirstUrls, ...otherImageUrls];

  // Verifica que el número de imágenes no exceda de 5
  const imagesToShow = images.slice(0, 5);

  // Calcular el total de imágenes disponibles
  const totalImages = images.length;
  console.log("total imagenees",imagesToShow)

  // Mostrar el número de imágenes restantes
  const remainingImages = totalImages - imagesToShow.length;

  // Función para manejar el click del botón "Ver más"
  const handleViewMore = () => {
    // Usamos `location.pathname` para obtener la ruta actual y agregarle '/gallery'
    const newPath = `${location.pathname}/gallery`; // Esto añadirá /gallery al final de la ruta actual
   // Navegar a la nueva ruta y pasar el estado con las imágenes
   navigate(newPath, { state: { images } });
  };

  console.log("Imágenes combinadas:", images);

  return (
    <div className="gallery-container">
      <div className="main-image">
        {/* Mostrar un cargador mientras se carga la imagen */}
        {isLoading && <FiestaSpinner/>}
        
        {/* Mostrar la primera imagen principal */}
        {imagesToShow.length > 0 && (
          <img
            src={imagesToShow[0]}
            alt="Evento principal"
            onLoad={() => setIsLoading(false)}
            onClick={handleViewMore}
          />
        )}
      </div>

      <div className="secondary-images">
        {/* Mostrar las imágenes secundarias */}
        {imagesToShow.slice(1).map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Evento ${index + 2}`}
            onLoad={() => setIsLoading(false)}
            onClick={handleViewMore}
          />
        ))}

        {/* Mostrar el botón "Ver más" si hay más imágenes */}
        {remainingImages > 0 && (
          <button className="view-more" onClick={handleViewMore}>
            Ver más (+{remainingImages})
          </button>
        )}
      </div>
    </div>
  );
};



// import React, { useEffect, useState } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import './galeryfirst.css';
// import FiestaSpinner from '../../../shared/FiestaSpinner';
// import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
// import Modal from 'react-modal';

// Modal.setAppElement('#root'); // Necesario para accesibilidad con react-modal

// export const GaleryFirst = ({ imagePrincipal, otherImages, videos }) => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [isVideoVisible, setIsVideoVisible] = useState(false); // Modal inicia cerrado
//   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [firstLoad, setFirstLoad] = useState(true); // 👈 bandera para evitar modal al render inicial

//   useEffect(() => {
//     if (firstLoad) {
//       setIsVideoVisible(false); // asegura que esté cerrado al inicio (incluso tras cache)
//       setFirstLoad(false);
//     }
//   }, [firstLoad]);

//   console.log("como inicia isVideoVisible",)

//   const otherImageUrls = otherImages.map(image => image.url);
//   const images = [imagePrincipal, ...otherImageUrls];
//   const imagesToShow = images.slice(0, 5);
//   const remainingImages = images.length - imagesToShow.length;

//   const handleViewMore = () => {
//     const newPath = `${location.pathname}/gallery`;
//     navigate(newPath, { state: { images } });
//   };

//   const handleViewVideoClick = () => {
//     setIsVideoVisible(true); // Aquí se abre el modal al dar clic
//   };

//   const closeModal = () => {
//     setIsVideoVisible(false);
//   };

//   const nextVideo = () => {
//     setCurrentVideoIndex((prev) => (prev + 1) % videos.length);
//   };

//   const prevVideo = () => {
//     setCurrentVideoIndex((prev) => (prev - 1 + videos.length) % videos.length);
//   };

//   return (
//     <div className="gallery-container">
//       <div className="main-image">
//         {isLoading && <FiestaSpinner />}
//         {imagesToShow.length > 0 && (
//           <img
//             src={imagesToShow[0]}
//             alt="Evento principal"
//             onLoad={() => setIsLoading(false)}
//             onClick={handleViewMore}
//           />
//         )}
//       </div>

//       <div className="secondary-images">
//         {imagesToShow.slice(1).map((src, index) => (
//           <img
//             key={index}
//             src={src}
//             alt={`Evento ${index + 2}`}
//             onLoad={() => setIsLoading(false)}
//             onClick={handleViewMore}
//           />
//         ))}

//         {remainingImages > 0 && (
//           <div className="buttons-container">
//             <button className="view-more" onClick={handleViewMore}>
//               Ver más (+{remainingImages})
//             </button>
//           </div>
//         )}

//         {videos && videos.length > 0 && (
//           <button className="view-video" onClick={handleViewVideoClick}>
//             Ver Video
//           </button>
//         )}
//       </div>

//       {/* 🟦 Modal controlado por estado */}
//       <Modal
//         isOpen={isVideoVisible}
//         onRequestClose={closeModal}
//         contentLabel="Video Modal"
//         className="modal-content"
//         overlayClassName="modal-overlay"
//       >
//         <button onClick={closeModal} className="video-close-btn">X</button>

//         <div className="video-container">
//           <iframe
//             id="facebook-video"
//             src={`https://www.facebook.com/plugins/video.php?href=${videos[currentVideoIndex]}&force_video=true&show_text=0&autoplay=1&muted=0&playsinline=true`}
//             width="100%"
//             height="100%"
//             scrolling="no"
//             frameBorder="0"
//             allowFullScreen
//             title="Facebook Video"
//           />
//         </div>

//         <div className="video-navigation">
//           <button onClick={prevVideo} className="nav-button left-arrow">
//             <FaArrowLeft size={30} />
//           </button>
//           <button onClick={nextVideo} className="nav-button right-arrow">
//             <FaArrowRight size={30} />
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// };
